import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '@sbd-doug-frontend/app/shared/shared.module';
import { ProcessMissingComponent } from './process-missing/process-missing.component';

const routes: Routes = [
  {
    path:'upcoming',
    loadChildren: () => import('./upcoming/upcoming-renewals.module').then(m => m.UpcomingRenewalsModule),
  },
  {
    path:'process-missing',
    component: ProcessMissingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, SharedModule]
})
export class RenewalsRoutingModule { }
